import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { REWARD_BOX_LABEL } from './translations'

import {
    hideGamefaceTooltip,
    showRewardBoxTooltip,
    REWARD_CATEGORY,
    REWARD_PACK_TYPE,
} from 'helpers/web_to_client'

import { getRewardCategory } from 'helpers/rewards'
import { CLIENT_HEADER_HEIGHT } from 'constants'

import styles from './RewardBox.scss'


export class RewardBox extends PureComponent {
    static propTypes = {
        rewards: PropTypes.array.isRequired,
        label: PropTypes.string,
        className: PropTypes.string,
    }

    componentWillUnmount() {
        clearTimeout(this._tooltipTimeoutId)
        document.removeEventListener('mousemove', this.handleMouseMove)
    }

    _tooltipTimeoutId = 0
    _clientCursorPosition = {}

    handleMouseLeave = () => {
        window.clearTimeout(this._tooltipTimeoutId)
        if (this._tooltipTimeoutId === undefined) {
            hideGamefaceTooltip()
            document.removeEventListener('mousemove', this.handleMouseMove)
        }
    }

    handleMouseMove = (e) => {
        this._clientCursorPosition = {
            x: e.pageX,
            y: e.pageY + CLIENT_HEADER_HEIGHT,
        }
    }

    handleMouseEnter = () => {
        document.addEventListener('mousemove', this.handleMouseMove)

        const tooltipRewards = this.props.rewards.reduce((config, item) => {

            // client bug need to be fixed: type for EMBLEM is not 'decal/1' for single tooltip
            const type = (item.type === REWARD_PACK_TYPE.DECAL_1) ? REWARD_PACK_TYPE.EMBLEM : item.type

            const category = getRewardCategory(type)
            if (!category) {
                return config
            }
            if (!config.hasOwnProperty(category)) {
                config[category] = []
            }

            if (category === REWARD_CATEGORY.CUSTOMIZATIONS) {
                config[category].push({
                    ...item,
                    custType: type.split('/')[0],
                })
            }

            return config
        }, {})

        this._tooltipTimeoutId = window.setTimeout(() => {
            const { x, y } = this._clientCursorPosition
            showRewardBoxTooltip(x, y, tooltipRewards)
            this._tooltipTimeoutId = undefined
        }, 200)
    }

    render() {
        const { label, className, rewards } = this.props

        return (
            <div
                className={cx(styles.base, className)}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <div className={styles.label}>
                    {label ? label : REWARD_BOX_LABEL(rewards.length)}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/RewardBox/RewardBox.jsx